module.exports = __webpack_public_path__ + "img/lan_tour_00.3c54318a.jpg";